import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ServicesModule } from './services/services.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GuestLayoutModule } from './common/layouts/guest-layout/guest-layout.module';
import { GuestWhiteModule } from './common/layouts/guest-white/guest-white.module';
import { UserLayoutModule } from './common/layouts/user-layout/user-layout.module';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { DirectivesModule } from './common/directives/directives.module';
import { KSpinnerModule } from './common/ui/k-spinner/k-spinner.module';
import { DEFAULT_TIMEOUT, HttpInterceptorService } from './services/interceptor/http-interceptor.service';
import { WalletInterceptor } from './services/interceptor/wallet-interceptor.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { activitiesFilterPipe, assetFilterPipe, itemsFilterPipe, itemsFilterTypePipe, kryptomonMainPowerPipe, kryptomonMarketRankingPipe, kryptomonRankingPipe, kryptomonSecondPowerPipe, merchFilterPipe, spellsOnboardingFilterPipe } from './common/pipes/itemsFilter.pipe';
import { ShopComponent } from './modules/user/old-components/shop/shop.component';
// import { KryptomonsComponentOLD } from './modules/user/old-components/kryptomons/kryptomons.component';
import { AssetsComponent } from './modules/user/old-components/assets/assets.component';
import { AssetDetailsComponent } from './modules/user/old-components/assets/details/details.component';
// import { DetailsComponent } from './modules/user/old-components/kryptomons/details/details.component';
import { BreedingCenterComponent } from './modules/user/old-components/breeding-center/breeding-center.component';
import { StakingComponent } from './modules/user/old-components/staking/staking.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MerchandiseComponent } from './modules/user/old-components/merchandise/merchandise.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReferralComponent } from './modules/user/old-components/referral/referral.component';
import { ShareModule } from 'ngx-sharebuttons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { ClaimComponent } from './modules/user/old-components/claim/claim.component';
import { WizardComponent } from './modules/user/old-components/wizard/wizard.component';
import { SliderModule } from 'primeng/slider';
import { TagInputModule } from 'ngx-chips';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RentingHouseComponent } from './modules/user/old-components/renting-house/renting-house.component';
import { PlayComponent } from './modules/user/old-components/play/play.component';
import { CommunityComponent } from './modules/user/old-components/community/community.component';
import { AcademyComponent } from './modules/user/old-components/academy/academy.component';
import { KButtonModule } from './common/ui/k-button/k-button.module';
import { KmonComponent } from './modules/user/old-components/kmon/kmon.component';
import { BalancefillComponent } from './modules/user/old-components/onboarding/balancefill/balancefill.component';
import { CompleteComponent } from './modules/user/old-components/onboarding/complete/complete.component';
import { FindComponent } from './modules/user/old-components/onboarding/find/find.component';
import { FirstLootboxComponent } from './modules/user/old-components/onboarding/first-lootbox/first-lootbox.component';
import { OnboardingComponent } from './modules/user/old-components/onboarding/onboarding.component';
import { StartComponent } from './modules/user/old-components/onboarding/start/start.component';
import { F2pNewComponent } from './modules/user/old-components/onboarding/f2p-new/f2p-new.component';
import { TranslocoModule } from '@ngneat/transloco';
import { RouteReuseStrategy } from '@angular/router';
import * as Hammer from 'hammerjs';
import { OnboardingLayoutModule } from './common/layouts/onboarding-layout/onboarding-layout.module';
import { WelcomePageModule } from './modules/user/welcome-page/welcome-page.module';
import { KryptomonMigrateModule } from './modules/user/kryptomons/kryptomon-migrate-dialog/kryptomon-migrate.module'
import { MbSaleComponent } from './modules/user/old-components/mb-sale/mb-sale.component';
import { MigrationLayoutModule } from './common/layouts/migration-layout/migration-layout.module';
import { KDropdownButtonModule } from 'app/common/ui/k-dropdown-button/k-dropdown-button.module';
// import { StripeModule } from 'app/common/components/stripe/stripe.module';
import { PaypalModule } from 'app/common/components/paypal/paypal.module';
import { PaypalComponent } from './common/components/paypal/paypal.component';
import { PipesModule } from './common/pipes/pipes.module';
import { isLocal } from 'environments/local/is.local';
import { NewVersionDialogModule } from './common/components/new-version-dialog/new-version-dialog.module';



export class HammerConfig extends HammerGestureConfig {
  override overrides = <any>{
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}



@NgModule({
  declarations: [
    AppComponent,
    ShopComponent,
    AssetsComponent,
    AssetDetailsComponent,
    // KryptomonsComponentOLD,
    // DetailsComponent,
    BreedingCenterComponent,
    StakingComponent,
    ReferralComponent,
    ClaimComponent,
    RentingHouseComponent,
    PlayComponent,
    CommunityComponent,
    AcademyComponent,
    KmonComponent,
    OnboardingComponent,
    StartComponent,
    FindComponent,
    BalancefillComponent,
    FirstLootboxComponent,
    CompleteComponent,
    F2pNewComponent,
    MerchandiseComponent,
    MbSaleComponent,
    itemsFilterPipe,
    WizardComponent,
    assetFilterPipe,
    kryptomonRankingPipe,
    activitiesFilterPipe,
    itemsFilterTypePipe,
    merchFilterPipe,
    kryptomonMarketRankingPipe,
    kryptomonMainPowerPipe,
    kryptomonSecondPowerPipe,
    spellsOnboardingFilterPipe,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ServicesModule,
    DirectivesModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isLocal,//!isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    GuestLayoutModule,
    GuestWhiteModule,
    UserLayoutModule,
    OnboardingLayoutModule,
    MigrationLayoutModule,
    KSpinnerModule,
    WelcomePageModule,
    ToastModule,
    FontAwesomeModule,
    BrowserAnimationsModule,//it is necessary for Staking old component, remove it when apply lazyloading
    TranslocoModule,
    FormsModule,//it is necessary for Staking old component, remove it when apply lazyloading
    ShareModule,//it is necessary for referral old component, remove it when apply lazyloading
    SliderModule,//it is necessary for marketplace (wizard) old component, remove it when apply lazyloading
    InfiniteScrollModule,//it is necessary for marketplace (wizard) old component, remove it when apply lazyloading
    TagInputModule,//it is necessary for marketplace (wizard) old component, remove it when apply lazyloading
    KButtonModule,//it is necessary for marketplace (wizard) old component and merchandise, remove it when apply lazyloading
    ReactiveFormsModule,//it is necessary for merchandise old component, remove it when apply lazyloading,
    KryptomonMigrateModule,//it is necessary for kryptomons details old component, remove it when apply lazyloading,
    KDropdownButtonModule,
    // StripeModule,
    PaypalModule,
    PipesModule,
    NewVersionDialogModule
  ],
  providers: [
    FindComponent,
    // { provide: RouteReuseStrategy, useClass: RouteReuseStrategy },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    { provide: DEFAULT_TIMEOUT, useValue: 60000 },
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(
    library: FaIconLibrary,
    walletInteceptor: WalletInterceptor) {
    library.addIconPacks(fas, far, fab);
    walletInteceptor.load();
  }

}
